export default {
    state: {
        totalSalesDepartments: [],
        fromToTotalSales: {from: '', to: ''},
        headerTotalSalesDepartments: ['Departments', 'Sales'],

        totalProcessesByStockroom: [],
        fromToTotalProcesses: {from: '', to: ''},
        headerProcessesByStockroom: ['Username', 'Count'],

        totalPayments: [],
        fromToTotalPayments: {from: '', to: ''},
        headerTotalPayments: ['Description', 'Amount'],

        loading: {
            totalSales: false,
            totalProcesses: false,
            totalPayments: false,
        },
    },
    mutations: {
        setTotalSalesDepartments(state, payload) {
            state.totalSalesDepartments = [];
            state.totalSalesDepartments.push(state.headerTotalSalesDepartments);

            payload.data.forEach((elem) => {
                state.totalSalesDepartments.push([elem.name, elem.total_sales]);
            });
            state.fromToTotalSales.from = payload.from;
            state.fromToTotalSales.to = payload.to;
        },
        setLoadingTotalSales(state, payload) {
            state.loading.totalSales = payload;
        },
        setTotalProcessesByStockroom(state, payload) {
            state.totalProcessesByStockroom = [];
            state.totalProcessesByStockroom.push(state.headerProcessesByStockroom);

            payload.data.forEach((elem) => {
                state.totalProcessesByStockroom.push([elem.username, elem.total_processed]);
            });
            state.fromToTotalProcesses.from = payload.from;
            state.fromToTotalProcesses.to = payload.to;
        },
        setLoadingTotalProcesses(state, payload) {
            state.loading.totalProcesses = payload;
        },
        setTotalPayments(state, payload) {
            state.totalPayments = [];
            state.totalPayments.push(state.headerTotalPayments);

            payload.data.forEach((elem) => {
                state.totalPayments.push([elem.description, parseFloat(elem.total_amount.toFixed(2))]);
            });
            state.fromToTotalPayments.from = payload.from;
            state.fromToTotalPayments.to = payload.to;
        },
        setLoadingTotalPayments(state, payload) {
            state.loading.totalPayments = payload;
        },
    },
    actions: {
        setTotalSalesDepartments({commit}, payload) {
            commit('setTotalSalesDepartments', payload);
        },
        setLoadingTotalSales({commit}, payload) {
            commit('setLoadingTotalSales', payload);
        },
        setTotalProcessesByStockroom({commit}, payload) {
            commit('setTotalProcessesByStockroom', payload);
        },
        setLoadingTotalProcesses({commit}, payload) {
            commit('setLoadingTotalProcesses', payload);
        },
        setTotalPayments({commit}, payload) {
            commit('setTTotalPayments', payload);
        },
        setLoadingTotalPayments({commit}, payload) {
            commit('setLoadingTotalPayments', payload);
        },
    },
    getters: {
        getTotalSalesDepartments(state) {
            return state.totalSalesDepartments;
        },
        getFromTotalSales(state) {
            return state.fromToTotalSales.from;
        },
        getToTotalSales(state) {
            return state.fromToTotalSales.to;
        },
        getLoadingTotalSales(state) {
            return state.loading.totalSales;
        },
        getTotalProcessesByStockroom(state) {
            return state.totalProcessesByStockroom;
        },
        getFromTotalProcesses(state) {
            return state.fromToTotalProcesses.from;
        },
        getToTotalProcesses(state) {
            return state.fromToTotalProcesses.to;
        },
        getLoadingTotalProcesses(state) {
            return state.loading.totalProcesses;
        },
        getTotalPayments(state) {
            return state.totalPayments;
        },
        getFromTotalPayments(state) {
            return state.fromToTotalPayments.from;
        },
        getToTotalPayments(state) {
            return state.fromToTotalPayments.to;
        },
        getLoadingTotalPayments(state) {
            return state.loading.totalPayments;
        },
    }
}
